import styled from "styled-components";

import FnrTypography from "UI/FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";

import { useCopyTextColor } from "../stateHooks";

const PrayerRequestVeriage = () => {
  const color = useCopyTextColor();

  return (
    <Wrapper>
      <SubWrapper>
        <FnrContainedIcon size="xs" icon="user fas" color={color} />
        <FnrTypography fontSize="xs" color={color}>
          Your name will be posted with your submission
        </FnrTypography>
      </SubWrapper>
      <SubWrapper>
        <FnrContainedIcon size="xs" icon="eye-slash fas" color={color} />
        <FnrTypography fontSize="xs" color={color}>
          Only prayer admins at your church can view your submission
        </FnrTypography>
      </SubWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: -8px 36px 16px 36px;
  gap: 2px;
`;

const SubWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export default PrayerRequestVeriage;
